skrilla.controller('matchPlaceholdersModalCtrl', function ($scope, cacheService, modalService) {

    $scope.sport = cacheService.getObjectOrElse("contestSport", function(){
        modalService.dismissAll();
    });
    $scope.selectMatch = cacheService.getObject("matchPlaceholdersFunction")

});